// project imports
import { withAlpha } from 'utils/colorUtils';

// ==============================|| DEFAULT THEME - CUSTOM SHADOWS ||============================== //

export default function CustomShadows(palette) {
  return {
    button: `0 8px 20px ${withAlpha(palette.grey[900], 0.08)}`,
    text: `0 -1px 0 rgb(0 0 0 / 12%)`,
    z1: `0 10px 30px ${withAlpha(palette.grey[900], 0.08)}`,
    primary: `0 0 0 3px ${withAlpha(palette.primary.main, 0.14)}`,
    secondary: `0 0 0 3px ${withAlpha(palette.secondary.main, 0.12)}`,
    error: `0 0 0 3px ${withAlpha(palette.error.main, 0.14)}`,
    warning: `0 0 0 3px ${withAlpha(palette.warning.main, 0.16)}`,
    info: `0 0 0 3px ${withAlpha(palette.info.main, 0.14)}`,
    success: `0 0 0 3px ${withAlpha(palette.success.main, 0.14)}`,
    grey: `0 0 0 3px ${withAlpha(palette.grey[500], 0.14)}`,
    primaryButton: `0 12px 24px ${withAlpha(palette.primary.main, 0.18)}`,
    secondaryButton: `0 12px 24px ${withAlpha(palette.secondary.main, 0.16)}`,
    errorButton: `0 12px 24px ${withAlpha(palette.error.main, 0.16)}`,
    warningButton: `0 12px 24px ${withAlpha(palette.warning.main, 0.18)}`,
    infoButton: `0 12px 24px ${withAlpha(palette.info.main, 0.16)}`,
    successButton: `0 12px 24px ${withAlpha(palette.success.main, 0.16)}`,
    greyButton: `0 12px 24px ${withAlpha(palette.grey[500], 0.16)}`
  };
}
